export default "__VITE_ASSET__Mwp9A0F3__"